import { render, staticRenderFns } from "./profile-dropdown.vue?vue&type=template&id=dc7b658c&"
import script from "./profile-dropdown.vue?vue&type=script&lang=js&"
export * from "./profile-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports